import { cx } from "shared/utils";

export const Stepper = ({
  currentStepIdx,
  totalSteps
}: {
  currentStepIdx: number;
  totalSteps: number;
}) => {
  return (
    <div>
      <p className="text-xs font-medium text-content-400 mb-4">
        Step {currentStepIdx + 1} / {totalSteps}
      </p>
      <div className="flex items-center gap-1">
        {Array.from({ length: totalSteps }).map((_, index) => (
          <div
            key={index}
            className={cx(
              "w-full h-0.5 rounded-full transition-all duration-300",
              currentStepIdx >= index ? " bg-primary-500" : " bg-alpha-40"
            )}
          ></div>
        ))}
      </div>
    </div>
  );
};
